export enum NodeType {
  Workspace = 'Workspace',
  WorkspaceSchema = 'WorkspaceSchema',
  SystemWorkspace = 'SystemWorkspace',
  AdminWorkspace = 'AdminWorkspace',
  Schema = 'Schema',
  SchemaForm = 'SchemaForm',
  UserSetting = 'UserSetting',
  WorkspaceSetting = 'WorkspaceSetting',
  View = 'View',
  Card = 'Card',
  Item = 'Item',
  PlanItem = 'PlanItem',
  CPPItem = 'CPPItem',
  UseCase = 'UseCase',
  Market = 'Market',
  Employee = 'Employee',
  Manager = 'Manager',
  PN = 'PN',
  PNTile = 'PNTile',
  PNFrame = 'PNFrame',
  MaintenanceCOEProposal = 'MaintenanceCoeProposal',
  ResearchModel = 'ResearchModel',
  ContentType = 'ContentType',
  ContentSubtype = 'ContentSubtype',
  ContextType = 'ContextType',
  GTPCapability = 'GTPCapability',
  GTPLayer = 'GTPLayer',
  GTPUseCase = 'GTPUseCase',
  StatusCategory = 'StatusCategory',
  Status = 'Status',
  KeyInitiative = 'KeyInitiative',
  Function = 'Function',
  CoreTopic = 'CoreTopic',
  ClientQuestion = 'ClientQuestion',
  Role = 'Role',
  Folder = 'Folder',
  SchemalessFilter = 'SchemalessFilter',
  Comment = 'Comment',
  Practice = 'Practice',
  DataSource = 'DataSource',
  Project = 'Project',
  DisrupterGroup = 'DisrupterGroup',
  DisrupterTopic = 'DisrupterTopic',
  Conference = 'Conference',
  SessionType = 'ConfSessionType',
  ConferenceSeries = 'ConferenceSeries',
  ConferenceTopic = 'ConferenceTopic',
  Track = 'ConfTrack',
  DemandQuestion = 'DemandQuestion',
  TopicCategory = 'TopicCategory',
  TaxonomyTag = 'TaxonomyTag',
  RolePriority = 'RolePriority',
  PriorityJourneyStep = 'PriorityJourneyStep',
  Entitlement = 'Entitlement',
  Position = 'Position',
  Series = 'Series',
  ContentItem = 'ContentItem'
}
